export default __webpack_public_path__ + "static/media/sharkOpen.29787987.jpg";